import type { Usuario } from "~/@types/schemas/usuario";
import { useAuthStore } from "~/store/auth"

export default defineNuxtRouteMiddleware((to) => {
  try {
    const authStore = useAuthStore();
    const { authenticated, token } = storeToRefs(authStore);

    if (!token?.value) authStore.$reset();

    const meta: CustomRouteMeta = to.meta;
    authenticated.value = token?.value ? true : false;

    if (authenticated.value) {
      if (!authStore.user) throw new AbortError('Você precisa estar autenticado para acessar esta página', '/login')
      if (meta.unauthOnly) throw new AbortError('Você já está autenticado');

      const user: Usuario = authStore.user;

      if (meta.require) {
        const required = Array.isArray(meta.require) ? meta.require : [meta.require];
        const hasAccess = required.some(role => {
          return user?.tipo?.[role] === true;
        });
      
        if (!hasAccess) throw new AbortError('Acesso restrito');
      }
    }
    else if (meta.authOnly) {
      throw new AbortError('Você precisa estar autenticado para acessar esta página', '/login');
    }
  }
  // @ts-ignore
  catch (error: AbortError) {
    abortNavigation();
    warnToast(error.message);
    return navigateTo(error.redirect);
  }
})